import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import API from "../config/api.js";

export default function Header({ onToggleMenu }) {
  const { user, manager, loading } = useAuth();

  const [searchValue, setSearchValue] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);
  const navigate = useNavigate();

  const goTo = (path) => {
    const query = searchValue.trim()
      ? `?search=${encodeURIComponent(searchValue.trim())}`
      : "";

    navigate(`/${path}${query}`);
    setShowSuggestions(false);
  };

  const userName = user?.name || "User";

  return (
    <header className="bg-white fixed-top">
      <div>
        <div className="row g-0 justify-content-between align-items-stretch">
          <div className="col-2 border-end text-start py-2 px-3 d-none d-md-block bg-secondary-light d-md-flex align-items-center">
            <Link to="/for-you" className="d-inline-block">
              <img
                src="/assets/img/travelagentcollective/favicon.png"
                className="img-fluid ms-2"
                width="35"
                height="35"
                alt=""
              />
            </Link>
          </div>

          <div className="col-4 text-start p-2 border-bottom d-block d-sm-none">
            <button
              type="button"
              className="btn btn-lg d-inline-block me-2"
              onClick={onToggleMenu}
            >
              <i className="fi fi-rr-menu-burger"></i>
            </button>

            <Link to="/home" className="d-inline-block">
              <img
                src="/assets/img/travelagentcollective/favicon.png"
                className="img-fluid ms-2"
                width="35"
                height="35"
                alt=""
              />
            </Link>
          </div>

          <div className="col-8 col-md-10 text-end border-bottom">
            <div className="p-1 pt-3 pt-sm-1 px-md-4">
              <div className="row align-items-center">
                <div className="col-6 col-md-4 text-start">
                  <div className="position-relative">
                    <div className="input-group border-0">
                      <span className="input-group-text bg-transparent border-0 text-muted">
                        <i className="fi fi-rr-search"></i>
                      </span>

                      <input
                        type="text"
                        className="form-control form-control-sm border-0 bg-transparent"
                        placeholder="Search"
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                        onFocus={() => setShowSuggestions(true)}
                        onBlur={() =>
                          setTimeout(() => setShowSuggestions(false), 200)
                        }
                      />

                      <button
                        type="button"
                        className={`btn border-0 ${!searchValue ? "d-none" : ""}`}
                        onClick={() => setSearchValue("")}
                      >
                        <i className="fi fi-rr-x small"></i>
                      </button>
                    </div>

                    {showSuggestions && searchValue && (
                      <div
                        className="bg-white text-start rounded p-2 shadow position-absolute w-100"
                        style={{ zIndex: 20, top: "100%", left: 0 }}
                      >
                        <button
                          type="button"
                          className="btn w-100 text-start"
                          onClick={() => goTo("captions")}
                        >
                          <i
                            className="fi fi-sr-text"
                            style={{ color: "#0FB8CE" }}
                          ></i>{" "}
                          Search <strong>resource</strong> in Captions
                        </button>

                        <button
                          type="button"
                          className="btn w-100 text-start"
                          onClick={() => goTo("images")}
                        >
                          <i
                            className="fi fi-sr-picture"
                            style={{ color: "#21A663" }}
                          ></i>{" "}
                          Search <strong>resource</strong> in Photos
                        </button>

                        <button
                          type="button"
                          className="btn w-100 text-start"
                          onClick={() => goTo("stories")}
                        >
                          <i
                            className="fi fi-sr-layout-fluid"
                            style={{ color: "#FF9900" }}
                          ></i>{" "}
                          Search <strong>resource</strong> in Stories
                        </button>

                        <button
                          type="button"
                          className="btn w-100 text-start"
                          onClick={() => goTo("reels")}
                        >
                          <i
                            className="fi fi-sr-play-alt"
                            style={{ color: "#FF5154" }}
                          ></i>{" "}
                          Search <strong>resource</strong> in Reels
                        </button>

                      <button
  type="button"
  className="btn w-100 text-start"
  onClick={() => goTo("videos")}
>
  <i
    className="fi fi-sr-film"
    style={{ color: "#8B5CF6" }}
  ></i>{" "}
  Search <strong>resource</strong> in Videos
</button>

                      </div>
                    )}
                  </div>
                </div>

                <div className="col-6 col-md-8 text-end">
                  <span className="dropdown d-none d-md-inline-block">
                    <button
                      className="btn btn-outline-primary"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      disabled={loading}
                    >
                      <img
                        width="28"
                        src="/assets/img/profile-facebook.png"
                        className="rounded-circle me-2"
                        alt="Profile"
                      />
                      {userName}{" "}
                      <i className="fi fi-rr-angle-small-down ms-2"></i>
                    </button>

                    <ul className="dropdown-menu shadow">
                      <li>
                        <Link className="dropdown-item" to="/account">
                          Account Settings
                        </Link>
                      </li>
                      {user.limitedexperience == null ? (
                        <li>
                          <Link className="dropdown-item" to="/preferences">
                            My Preferences
                          </Link>
                        </li>
                      ) : null}

                      {manager ? (
                        <li>
                          <a
                          className="dropdown-item"
                          href={`${API.baseUrl}/panel-social-media-manager`}
                        >
                          Social Media Manager
                        </a>
                        </li>
                      ) : null}
                      <li>
                        <a
                          className="dropdown-item"
                          href="https://help.travelagentcollective.com/en"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Help Center
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href={`${API.baseUrl}/sign-in`}
                        >
                          Sign Out
                        </a>
                      </li>
                    </ul>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
